import { PrinterSchema } from "@redotech/redo-fulfillment-group-common/printer";
import * as z from "zod";

export const getPrinters = {
  name: "getPrinters" as const,
  input: z.object({}),
  output: z.object({ enabled: z.boolean(), printers: z.array(PrinterSchema) }),
};
